/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Masthead from "./Masthead";
import Footer from "./Footer";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = ({ children, ...props }) => {

	return (
		<div className="bdoContainer">
			<Masthead />
			{children}
			<Footer />
		</div>
	);
};
